import styled from "styled-components";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Carousel from "./Carousel";


const Projects = (props) => {

    

    return(
        <Container>
            <Content>
                <Caption>
                    <span>Our Projects</span>
                    <h2>All the work that we do</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <br/> incididunt ut labore et dolore magna aliqua.</p>
                </Caption>
                <Carousel />
            </Content>
        </Container>
    )
}


const Container = styled.div`
    background: rgb(249, 250, 251);
    text-align: center;
    padding: 50px 20px;

`

const Content = styled.div``

const Caption = styled.div`
    span{
        color: rgb(231, 60, 62);
    }
`

export default Projects